import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import PodcastsIcon from "@mui/icons-material/Podcasts";
import { Box, Typography } from "@mui/material";
import Divider from '@mui/material/Divider';
import Subscribe from "./Subscribe";
import { Link as RouterLink } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <Box
        sx={{ textAlign: "center", bgcolor: "#fef7ed", color: "#1A1A19", p: 1 }}
      >
        <Box
          sx={{
            my: 3,
            "& svg": {
              fontSize: "60px",
              cursor: "pointer",
              mr: 1,
            },
            "& svg:hover": {
              color: "goldenrod",
              transform: "translateX(5px)",
              transition: "all 400ms",
            },
          }}
        >
          <Typography variant="h5" sx={{ color: '#1A1A19' }}>
            <Divider>Connect With Me</Divider><br />
          </Typography>
          <a href="https://www.instagram.com/indianpetvet/" className="Instagram social" target="_blank" >
            <InstagramIcon />
          </a>
          <a href="https://www.facebook.com/indianpetvet/" className="Facebook social" target="_blank">
            <FacebookIcon />
          </a>
           <a
    href="https://www.youtube.com/@indianpetvet"
    target="_blank"
    rel="noopener noreferrer"
  >
    <YouTubeIcon sx={{ fontSize: 45, color: "#FF0000" }} />
  </a>

  <a
    href="https://open.spotify.com/show/6iD265V8RaNrbkDJxQjlwv"
    target="_blank"
    rel="noopener noreferrer"
  >
    <PodcastsIcon sx={{ fontSize: 45, color: "#1DB954" }} />
    {/* or <HeadphonesIcon /> */}
  </a>
        </Box>
        <Typography variant="h6" sx={{ color: '#1A1A19' }}>
          Subscribe to never miss a new upload!<br />
        </Typography>
        <Subscribe />
      </Box>
<Typography
  component={RouterLink}
  to="/privacy-policy"
  sx={{
    display: "block",
    textAlign: "center",
    mt: 2,
    mb: 2,
    textDecoration: "none",
    color: "#3a54b4",
    fontWeight: 600,
    fontSize: "1rem",
    transition: "color 0.3s ease",
    "&:hover": {
      color: "#1e88e5",
      textDecoration: "underline",
    },
  }}
>
  Privacy Policy
</Typography>
    </>
    
  );
};

export default Footer;